/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterDto } from '../../models/mitarbeiter-dto';

export interface GetAbteilungsleiter$Plain$Params {
  abteilungId: string;
}

export function getAbteilungsleiter$Plain(http: HttpClient, rootUrl: string, params: GetAbteilungsleiter$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MitarbeiterDto>> {
  const rb = new RequestBuilder(rootUrl, getAbteilungsleiter$Plain.PATH, 'get');
  if (params) {
    rb.path('abteilungId', params.abteilungId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MitarbeiterDto>;
    })
  );
}

getAbteilungsleiter$Plain.PATH = '/v1/abteilungen/{abteilungId}/leiter';
